import {getServerRequest,patchServerRequest} from '../../helpers/serverRequest.helper';
import { store } from '../../store/store';

const httpURL = store.getters.httpURL;

export const cargarOficiosEntrantesPersonalesService = async(page, search,filter) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/personales/entrantes?page=${page}&search=${search}&filter=${filter}`;
    return await getServerRequest(url, config);
}
export const cargarOficiosGeneradosPersonalesService = async(page, search,filter) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/personales/generados?page=${page}&search=${search}&filter=${filter}`;
    return await getServerRequest(url, config);
}

export const terminarOficio = async(tipo, id) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/${tipo}/terminarOficio/${id}`;
    return await patchServerRequest(url, {}, config);
}